export const ServerConfiguration = {

    LiveServerUrl: "https://yawei.com.my/YaweiLogisticApi/api/YaweiLogistic/",
    // LiveServerUrl: "http://localhost/YaweiLogisticApi/api/YaweiLogistic/",
    uploadUrl: "https://yawei.com.my/YaweiLogisticImage/upload.php"
}